import { useState, useRef } from "react";
import { Container, Row, Col } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";

export default function Manual() {
  const hoverContainerRef = useRef(null);
  const hoverTrackRef = useRef(null);
  const [hoverTranslateX, setHoverTranslateX] = useState(0);

  const handleHoverMove = (event) => {
    const container = hoverContainerRef.current;
    const track = hoverTrackRef.current;
    if (!container || !track) return;

    const rect = container.getBoundingClientRect();
    const clientX = event.touches ? event.touches[0].clientX : event.clientX;
    const xWithin = Math.max(0, Math.min(rect.width, clientX - rect.left));
    const ratio = xWithin / rect.width;

    const overflow = Math.max(0, track.scrollWidth - container.clientWidth);
    const translate = -overflow * ratio;
    setHoverTranslateX(translate);
  };
  return (
    <section id="manual" className="py-5 bg-light">
      <Container>
        <Row className="text-center mb-4">
          <Col>
            <h2 className="display-5 fw-bold text-dark mb-3">
              Materiais: pode e não pode reciclar
            </h2>
            <p className="lead text-muted">
              Passe o mouse para mover as imagens para o lado.
            </p>
          </Col>
        </Row>
        <Row>
          <Col>
            <div
              className="hover-carousel rounded shadow-sm"
              ref={hoverContainerRef}
              onMouseMove={handleHoverMove}
              onTouchMove={handleHoverMove}
            >
              <div
                className="hover-carousel-track"
                ref={hoverTrackRef}
                style={{ transform: `translateX(${hoverTranslateX}px)` }}
              >
                {[
                  {
                    src: "/img/manual6.jpg",
                    title: "Materiais que podem",
                    desc: "Papéis limpos, papelão, vidros, plásticos e metais.",
                  },
                  {
                    src: "/img/manual5.jpg",
                    title: "O que não vai",
                    desc: "Papel higiênico, guardanapo usado, fraldas, absorventes e orgânicos.",
                  },
                  {
                    src: "/img/manual4.jpg",
                    title: "Limpe os frascos",
                    desc: "Enxágue embalagens para evitar contaminação e odores.",
                  },
                  {
                    src: "/img/manual3.jpg",
                    title: "Evite resíduos sujos",
                    desc: "Remova restos de comida e líquidos antes de descartar.",
                  },
                  {
                    src: "/img/manual2.jpg",
                    title: "Use lixeiras específicas",
                    desc: "Separe por tipo de material quando possível.",
                  },
                  {
                    src: "/img/manual1.jpg",
                    title: "Resíduos de lixo comum",
                    desc: "Itens não recicláveis devem ir ao lixo comum.",
                  },
                ].map((item, index) => (
                  <div
                    key={`hover-item-${index}`}
                    className="hover-carousel-item"
                  >
                    <div className="hover-carousel-media">
                      <img
                        src={item.src}
                        alt={item.title}
                        className="hover-carousel-image"
                        title={item.title}
                      />
                    </div>
                    <div className="hover-carousel-caption">
                      <h6 className="mb-1 fw-bold">{item.title}</h6>
                      <p className="mb-0 small text-muted">{item.desc}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}
